import React, { useState } from 'react';
import theme from './ImageUpload.module.scss';
import { FileData } from '@ygtechnologies/rubus-frontend-utilities';
import { AspectRatioContainer, FileUpload, ImageCropDialog, Thumbnail } from '@ygtechnologies/bygr-frontend-component-library';
import { rotateImage } from '@ygtechnologies/rubus-frontend-utilities';

interface ImageUploadProps {
    onChange(image: any): void;
    currentImage: string | FileData | null;
    aspectRatio: number;
    previewSize?: number;
    previewClassName?: string;
    readonly?: boolean;
    containerClassName?: string;
    shouldCrop?: boolean;
}

const ImageUpload: React.FC<ImageUploadProps> = ({
    onChange,
    currentImage,
    aspectRatio,
    previewSize = 1,
    previewClassName = null,
    readonly = false,
    shouldCrop = true,
    containerClassName,
}) => {
    // const [uniqueId] = useState(() => getUniqueId());

    const [uploadedImage, setUploadedImage] = useState<FileData | null>(null);

    const handleFileSelect = async (files) => {
        const file = files[0];

        if (!file) {
            return;
        }
        if (shouldCrop) {
            setUploadedImage(new FileData(file));
        }
        if (!shouldCrop) {
            setUploadedImage(null);
            const flipped = await rotateImage(new FileData(file));
            onChange(flipped);
        }
    };

    const handleCropAccept = (croppedImage) => {
        setUploadedImage(null);
        onChange(croppedImage);
    };

    return (
        <>
            <ImageCropDialog
                aspect={aspectRatio}
                fileData={uploadedImage!}
                show={!!uploadedImage && shouldCrop}
                onCancel={() => setUploadedImage(null)}
                onAccept={handleCropAccept}
            />
            <FileUpload fileType="image" single containerClassName={containerClassName} onDrop={handleFileSelect} unstyled>
                <AspectRatioContainer aspect={aspectRatio / previewSize} innerClassName={theme.thumbnailWrapper}>
                    <Thumbnail isUpload className={theme.thumbnail} src={currentImage} />
                </AspectRatioContainer>
            </FileUpload>
            {/* <label
                htmlFor={uniqueId}
                className={classnames(theme.preview, previewClassName, { [theme.readonly]: readonly })}>
                <input id={uniqueId} type="file" onChange={handleFileSelect} disabled={readonly} />
                <AspectRatioContainer aspect={aspectRatio / previewSize} innerClassName={theme.thumbnailWrapper}>
                    <Thumbnail className={theme.thumbnail} src={currentImage} />
                </AspectRatioContainer>
            </label> */}
        </>
    );
};

export default ImageUpload;
